import { useCallback } from 'react';
import { buildMachineEnquiryUrl, buildGeneralEnquiryUrl } from '../utils';

/**
 * useWhatsApp – helpers to open WhatsApp with pre-typed messages.
 *
 * Usage:
 *   const { openEnquiry, openGeneral } = useWhatsApp();
 *   <button onClick={() => openEnquiry(machine)}>Buy on WhatsApp</button>
 */
export function useWhatsApp() {
  const openEnquiry = useCallback((machine) => {
    window.open(buildMachineEnquiryUrl(machine), '_blank', 'noopener,noreferrer');
  }, []);

  const openGeneral = useCallback(() => {
    window.open(buildGeneralEnquiryUrl(), '_blank', 'noopener,noreferrer');
  }, []);

  return { openEnquiry, openGeneral };
}
